import { Stack, Text, Button, ThemeIcon, Center } from '@mantine/core';
import { IconMoodEmpty } from '@tabler/icons-react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <Center py="xl">
      <Stack align="center" gap="md">
        <ThemeIcon variant="light" size={64} radius="xl" color="gray">
          {icon || <IconMoodEmpty size={32} />}
        </ThemeIcon>

        <Text fw={500} size="lg">
          {title}
        </Text>

        {description && (
          <Text c="dimmed" size="sm" ta="center" maw={400}>
            {description}
          </Text>
        )}

        {action && (
          <Button variant="light" onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </Stack>
    </Center>
  );
}
